// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a0ff870e","498":"c2c3b71c","703":"aab01207"}[chunkId] + ".chunk.js";
};